var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"my-0",class:_vm.styling,attrs:{"disabled":!_vm.to,"to":_vm.to}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":_vm.color,"left":"","size":"18"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1),_c('v-list-item-content',[_c('v-list-item-title',[_c('span',{domProps:{"textContent":_vm._s(_vm.title)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }